// Generated by ReScript, PLEASE EDIT WITH CARE

import * as RR from "common/src/RR.bs.js";
import * as Api from "../app-core/Api.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as Patch from "common/src/Patch.bs.js";
import * as React from "react";
import * as Config from "common/src/Config.bs.js";
import * as $$Promise from "common/src/Promise.bs.js";
import * as RankGroup from "common/src/RankGroup.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as ApertureCtx from "../ctx/ApertureCtx.bs.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as LocalStorage from "common/src/LocalStorage.bs.js";
import * as PlayerBookmark from "../player/PlayerBookmark.bs.js";
import * as Belt_MutableMapString from "rescript/lib/es6/belt_MutableMapString.js";

var data = Belt_MutableMapString.make(undefined);

function getStale(key) {
  return Belt_Option.map(Belt_MutableMapString.get(data, key), (function (param) {
                return param[1];
              }));
}

function getSwr(path, cb) {
  var match = Belt_MutableMapString.get(data, path);
  if (match === undefined) {
    return $$Promise.consume($$Promise.flatMap(fetch(path), (function (resp) {
                      return resp.json();
                    })), (function (d) {
                  Belt_MutableMapString.set(data, path, [
                        Date.now(),
                        d
                      ]);
                  return Curry._1(cb, {
                              TAG: /* Ok */0,
                              _0: d
                            });
                }));
  }
  var curr = Date.now();
  if (curr - match[0] > 5 * 60 * 1000) {
    $$Promise.consume($$Promise.flatMap(fetch(path), (function (resp) {
                return resp.json();
              })), (function (d) {
            return Belt_MutableMapString.set(data, path, [
                        Date.now(),
                        d
                      ]);
          }));
  }
  return Curry._1(cb, {
              TAG: /* Ok */0,
              _0: match[1]
            });
}

function getBase(key, getFn, cb) {
  var match = Belt_MutableMapString.get(data, key);
  if (match === undefined) {
    return Curry._1(getFn, (function (d) {
                  Belt_MutableMapString.set(data, key, [
                        Date.now(),
                        d
                      ]);
                  return Curry._1(cb, {
                              TAG: /* Ok */0,
                              _0: d
                            });
                }));
  }
  var curr = Date.now();
  if (curr - match[0] > 5 * 60 * 1000) {
    return Curry._1(getFn, (function (d) {
                  Belt_MutableMapString.set(data, key, [
                        Date.now(),
                        d
                      ]);
                  return Curry._1(cb, {
                              TAG: /* Ok */0,
                              _0: d
                            });
                }));
  } else {
    return Curry._1(cb, {
                TAG: /* Ok */0,
                _0: match[1]
              });
  }
}

function get(path, cb) {
  return getBase(path, (function (dataCb) {
                return $$Promise.consume($$Promise.flatMap(fetch(path), (function (resp) {
                                  return resp.json();
                                })), Curry.__1(dataCb));
              }), cb);
}

function useStats2(queueId) {
  var match = React.useState(function () {
        
      });
  var setData = match[1];
  var aperture = ApertureCtx.useValue(undefined);
  var url = "https://d3.tft.tools/stats2/general/" + String(queueId) + "/" + Patch.toApiUrl(aperture.patch) + "/" + RankGroup.toId(aperture.rankGroup);
  React.useEffect((function () {
          get(url, (function (d) {
                  if (d.TAG !== /* Ok */0) {
                    return ;
                  }
                  var d$1 = d._0;
                  return Curry._1(setData, (function (param) {
                                return d$1;
                              }));
                }));
          
        }), [aperture]);
  return match[0];
}

function useUnitStats2(unitId, starLevel, queueId) {
  var match = React.useState(function () {
        
      });
  var setData = match[1];
  var aperture = ApertureCtx.useValue(undefined);
  var unitStr = starLevel === 0 ? "/unit/" + String(queueId) + "/" + unitId : "/sunit/" + String(queueId) + "/" + unitId + "/" + String(starLevel);
  var url = "https://d3.tft.tools/stats2" + unitStr + "/" + Patch.toApiUrl(aperture.patch) + "/" + RankGroup.toId(aperture.rankGroup);
  React.useEffect((function () {
          Curry._1(setData, (function (param) {
                  
                }));
          get(url, (function (d) {
                  if (d.TAG !== /* Ok */0) {
                    return ;
                  }
                  var d$1 = d._0;
                  return Curry._1(setData, (function (param) {
                                return d$1;
                              }));
                }));
          
        }), [
        aperture,
        unitId,
        starLevel
      ]);
  return match[0];
}

function useTraitStats2(traitId, traitRank, queueId) {
  var match = React.useState(function () {
        
      });
  var setData = match[1];
  var aperture = ApertureCtx.useValue(undefined);
  var url = "https://d3.tft.tools/stats2/trait/" + String(queueId) + "/" + traitId + "/" + String(traitRank) + "/" + Patch.toApiUrl(aperture.patch) + "/" + RankGroup.toId(aperture.rankGroup);
  React.useEffect((function () {
          Curry._1(setData, (function (param) {
                  
                }));
          get(url, (function (d) {
                  if (d.TAG !== /* Ok */0) {
                    return ;
                  }
                  var d$1 = d._0;
                  return Curry._1(setData, (function (param) {
                                return d$1;
                              }));
                }));
          
        }), [
        aperture,
        traitId,
        traitRank
      ]);
  return match[0];
}

function useLeaderboards(regionKey) {
  var match = React.useState(function () {
        
      });
  var setData = match[1];
  var url = "https://api.tft.tools/ranked-leaderboards/" + regionKey;
  React.useEffect((function () {
          Curry._1(setData, (function (param) {
                  
                }));
          get(url, (function (d) {
                  if (d.TAG !== /* Ok */0) {
                    return ;
                  }
                  var d$1 = d._0;
                  return Curry._1(setData, (function (param) {
                                return d$1;
                              }));
                }));
          
        }), [regionKey]);
  return match[0];
}

function useHrLeaderboards(regionKey) {
  var match = React.useState(function () {
        
      });
  var setData = match[1];
  var url = "https://api.tft.tools/hr-leaderboards/" + regionKey;
  React.useEffect((function () {
          Curry._1(setData, (function (param) {
                  
                }));
          get(url, (function (d) {
                  if (d.TAG !== /* Ok */0) {
                    return ;
                  }
                  var d$1 = d._0;
                  return Curry._1(setData, (function (param) {
                                return d$1;
                              }));
                }));
          
        }), [regionKey]);
  return match[0];
}

function useComps(initialData, queueId) {
  var match = React.useState(function () {
        return [
                queueId,
                initialData
              ];
      });
  var setData = match[1];
  var aperture = ApertureCtx.useValue(undefined);
  var compsKey = queueId >= 1161 ? (
      queueId !== 6000 ? (
          queueId !== 6100 ? (
              queueId !== 6110 ? "team-compositions" : "rr-team-compositions"
            ) : "revival-team-compositions"
        ) : "galaxy-team-compositions"
    ) : (
      queueId !== 1100 ? (
          queueId !== 1130 ? (
              queueId >= 1160 ? "duo-team-compositions" : "team-compositions"
            ) : "hr-team-compositions"
        ) : "team-compositions"
    );
  var url = "https://api.tft.tools/" + compsKey + "/" + RankGroup.toId(aperture.rankGroup) + "/" + Patch.toApiUrl(aperture.patch);
  var prevQueue = React.useRef(aperture.queue);
  RR.useIsoLayoutEffect1((function (param) {
          if (prevQueue.current !== aperture.queue) {
            prevQueue.current = aperture.queue;
            Curry._1(setData, (function (param) {
                    
                  }));
          }
          get(url, (function (d) {
                  if (d.TAG !== /* Ok */0) {
                    return ;
                  }
                  var d$1 = d._0;
                  return Curry._1(setData, (function (param) {
                                return [
                                        queueId,
                                        d$1
                                      ];
                              }));
                }));
          
        }), [aperture]);
  return match[0];
}

function useHrComps(param) {
  var match = React.useState(function () {
        
      });
  var setData = match[1];
  var aperture = ApertureCtx.useValue(undefined);
  var url = "https://api.tft.tools/hr-team-compositions/3/" + String(Config.lastPatch);
  React.useEffect((function () {
          get(url, (function (d) {
                  if (d.TAG !== /* Ok */0) {
                    return ;
                  }
                  var d$1 = d._0;
                  return Curry._1(setData, (function (param) {
                                return d$1;
                              }));
                }));
          
        }), [aperture]);
  return match[0];
}

function useDuoComps(param) {
  var match = React.useState(function () {
        
      });
  var setData = match[1];
  var aperture = ApertureCtx.useValue(undefined);
  var url = "https://api.tft.tools/duo-team-compositions/3/" + String(Config.lastPatch);
  React.useEffect((function () {
          get(url, (function (d) {
                  if (d.TAG !== /* Ok */0) {
                    return ;
                  }
                  var d$1 = d._0;
                  return Curry._1(setData, (function (param) {
                                return d$1;
                              }));
                }));
          
        }), [aperture]);
  return match[0];
}

function usePerfectSynergies(set, ut, lvl, traitId) {
  var match = React.useState(function () {
        
      });
  var setData = match[1];
  React.useEffect((function () {
          Curry._1(setData, (function (param) {
                  
                }));
          var cancelled = {
            contents: false
          };
          var url = "https://api.tft.tools/static-data/perfect-synergies/" + String(set) + "/" + String(ut) + "/" + String(lvl) + "/" + Belt_Option.getWithDefault(traitId, "base");
          $$Promise.consume($$Promise.flatMap(fetch(url), (function (resp) {
                      return resp.json();
                    })), (function (json) {
                  if (!cancelled.contents) {
                    return Curry._1(setData, (function (param) {
                                  return json;
                                }));
                  }
                  
                }));
          return (function (param) {
                    cancelled.contents = true;
                    
                  });
        }), [
        set,
        ut,
        lvl,
        traitId
      ]);
  return match[0];
}

var personalLbKey = "bookmarks-leaderboards";

function useBookmarkLeaderboards(param) {
  var match = PlayerBookmark.use(undefined);
  var bookmarks = match[0];
  var match$1 = React.useState(function () {
        
      });
  var setLbData = match$1[1];
  RR.useIsoLayoutEffect0(function (param) {
        var v = LocalStorage.get(personalLbKey);
        if (!(v == null)) {
          Curry._1(setLbData, (function (param) {
                  return [
                          JSON.parse(v),
                          true
                        ];
                }));
        }
        
      });
  React.useEffect((function () {
          var cancelled = {
            contents: false
          };
          $$Promise.consume(Api.fetchPersonalLeaderboards3({
                    players: Belt_Array.map(bookmarks, PlayerBookmark.encode)
                  }), (function (leaderboardData) {
                  if (!cancelled.contents) {
                    Curry._1(setLbData, (function (param) {
                            return [
                                    leaderboardData,
                                    false
                                  ];
                          }));
                    setTimeout((function (param) {
                            return LocalStorage.set(personalLbKey, Belt_Option.getExn(JSON.stringify(leaderboardData)));
                          }), 0);
                    return ;
                  }
                  
                }));
          return (function (param) {
                    cancelled.contents = true;
                    
                  });
        }), [bookmarks]);
  return match$1[0];
}

export {
  data ,
  getStale ,
  getSwr ,
  getBase ,
  get ,
  useStats2 ,
  useUnitStats2 ,
  useTraitStats2 ,
  useLeaderboards ,
  useHrLeaderboards ,
  useComps ,
  useHrComps ,
  useDuoComps ,
  usePerfectSynergies ,
  personalLbKey ,
  useBookmarkLeaderboards ,
  
}
/* data Not a pure module */
